import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconParachute: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconParachute"><Path d="M9.5 16.5H14.5V21.5H9.5V16.5Z" stroke="currentColor"/><Path d="M22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5M22 12.5L15 18M22 12.5C18.5666 10.1297 15.2833 8.94449 12 8.94449M2 12.5L9 18M2 12.5C5.4334 10.1297 8.7167 8.94449 12 8.94449M12 8.94449V16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconParachute;
